
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="p" components={components}>{`C’est un travail d’une précision tout helvétique, qui a pris vingt ans. Ces dernières années, les cantons ont cartographié au mètre près les risques naturels pesant sur le territoire suisse. Ces cartes de dangers permettent de voir quelles zones sont les plus exposées aux inondations, avalanches, chutes de pierres ou glissements de terrain.`}</MDXTag>
<MDXTag name="p" components={components}>{`Presque toute la Suisse est désormais couverte par les cartes d’inondations et d’avalanches. Mais il est impossible de visualiser ces dangers pour tout le pays, car les cantons ont publié leurs cartes séparément sur internet. Ils ne fournissent pas non plus d’informations sur le nombre de personnes ou de bâtiments se trouvant dans des zones sensibles.`}</MDXTag>
<MDXTag name="p" components={components}>{`La cellule interactive de Tamedia a donc élaboré un outil qui permet de vérifier si votre adresse, ou n’importe quel endroit de Suisse, se trouve en zone de danger d’inondation ou d’avalanche.`}</MDXTag>
<MDXTag name="p" components={components}>{`Il montre que de larges régions de plaines sont exposées aux inondations, au point qu’un million de Suisses environ vivent en zone de danger modéré à élevé.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  